import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
export const fetchUrlStatus = async (parameters) => {
    const { data: DATA } = await PEGASUS.validateUrl({ encodedUrl: btoa(parameters.url) }, PROXY.getOptions());
    if ('status' in DATA) {
        return DATA;
    }
    return {};
};
